import TablePicker from 'components/Table/TablePicker/TablePicker';
import { deviceNumberSizes } from 'config/device';
import { useInfoAndData } from 'hooks/useInfoAndData';
import { useWindowSize } from 'hooks/useWindowResize';

import { ChartBody } from './ChartBody';

type Props = {
  data: any;
  description: string;
};

function ListCharts({ data, description }: Props) {
  const windowSize = useWindowSize();
  const isTabletDown = (windowSize.width ?? 0) <= deviceNumberSizes.tablet;

  const infoData = useInfoAndData({
    query: '',
    list: data.LIST,
    object: data.OBJECT,
    filters: data.FILTERS,
  });

  return (
    <ChartBody type='list' description={description} queryData={infoData}>
      <TablePicker
        type='Edit'
        tableOffset={11}
        enableA11y={false}
        valueData={infoData?.data?.data}
        keyData={infoData?.data?.infoData}
        mobileType={isTabletDown ? 'list' : undefined}
        showNavActions={false}
      />
    </ChartBody>
  );
}

export default ListCharts;
